import {
    Condition,
    Conditions,
    ConditionTypes,
    Operators,
} from "@tenforce/product-fields"
import { FilterParser } from "./index"
import { ConditionDTO } from "../../models/dto/conditions"

export const BooleanConditionDTOType = "#TF.BooleanFieldCondition"
export const BooleanFieldDefinitionType = "#TF.BoolFieldDefinition"
export enum BooleanOperatorDTO {
    IsEqualTo = "IsEqualTo",
}

const checkIfApplicable = (condition: Condition): boolean => {
    return condition?.type === ConditionTypes.Boolean
}

const parseFromDTO = (condition: ConditionDTO): Condition => {
    let result: Conditions["Boolean"] = null
    switch (condition.Operator) {
        case BooleanOperatorDTO.IsEqualTo: {
            result = {
                type: ConditionTypes.Boolean,
                operator: Operators.Boolean.IsEqualTo,
                isLocked: condition.IsLocked,
                value: condition.Value,
            }
            break
        }
        default:
            break
    }
    return result
}

const parseToDTO = (id: string, condition: Condition): ConditionDTO | null => {
    if (!condition || !checkIfApplicable(condition)) {
        return null
    }
    let result: ConditionDTO | null = null
    switch (condition.operator) {
        case Operators.Boolean.IsEqualTo: {
            result = {
                "@type": BooleanConditionDTOType,
                Operator: BooleanOperatorDTO.IsEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        default:
            break
    }
    return result
}

const parser: FilterParser = {
    Type: ConditionTypes.Boolean,
    DefinitionDTOType: BooleanFieldDefinitionType,
    checkIfApplicable,
    parseFromDTO,
    parseToDTO,
}
export default parser
